import {Component} from '@angular/core'
import {environment} from '../../../../environments/environment'

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <small><span class="created-by">Created by <b><a href="https://matejkamenec.cz" target="_blank">Matěj Kamenec</a></b> {{year}}</span></small>
    <span>{{version}}</span>
  `,
})
export class FooterComponent {
  version: string = environment.versions.app
  year: number = new Date().getFullYear()
}
